import React, { FC } from 'react'
import { styled } from '~/app/components'
import { Blink } from '~/app/components/common/Animations'

/**
 * WebSpinner component
 */
const Container = styled.div`
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
`

const Dot = styled.div<{ delay: number }>`
  width: 8px;
  height: 8px;
  background: #0091cf;
  border-radius: 50%;
  margin: 8px;
  opacity: 0;
  animation: ${Blink} 1.5s infinite;
  animation-delay: ${({ delay }) => delay}ms;
`

// WebSpinner component
const WebSpinner: FC = () => {
  return (
    <Container>
      <Dot delay={0} />
      <Dot delay={200} />
      <Dot delay={400} />
    </Container>
  )
}

export default WebSpinner
